const Layout = {
    appBarHeight: 64,
    drawerWidth: {
        md: 0,
        lg: 300
    },
};

export default Layout;